import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import EditCategory from "@/components/POI/EditCategory/EditCategory.vue";
import { flatten, sortBy } from "lodash";
import { PoiSteps } from "@/helpers/poiHelper";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "GlobalCategoryConfig",
  components: { EditCategory },
  props: [
    "categoryGroups",
    "selectedCategoryGroups",
    "width",
    "buttonText",
    "global",
    "selectedType",
    "isPoiAdmin"
  ],
  data: () => ({
    showCategoryInput: false,
    editedGroup: false,
    editedCategory: {
      title: "",
      shortTitle: "",
      pictureUrl: "",
      mappingField: "",
      valueType: "",
      categoryType: "",
      categoryGroup: "",
      parentCategory: ""
    },
    showCreateInput: false,
    createInputValue: "",
    createInputValid: false,
    poiSteps: PoiSteps
  }),
  methods: {
    toggleCategoryInput(id) {
      if (this.editedCategory && this.editedCategory.categoryType === id) {
        this.showCategoryInput = !this.showCategoryInput;
        this.editedCategory.categoryType = this.showCategoryInput ? id : null;
      } else {
        this.showCategoryInput = true;
        // If only the categoryGroup is set, the component doesn't rerender
        this.editedCategory = { ...this.editedCategory, categoryType: id };
      }
    },
    getCategoryGroups() {
      if (this.global) {
        return sortBy(
          this.categoryGroups.filter(
            cg => cg.categoryType === this.selectedType._id && !cg.owner
          ),
          "title"
        );
      } else {
        return sortBy(
          this.categoryGroups.filter(
            cg =>
              cg.categoryType === this.selectedType._id &&
              cg.owner &&
              cg.owner === this.selectedPrincipal?._id
          ),
          "title"
        );
      }
    },
    async saveGroup(global, createInputValue, type) {
      this.createInputValid = true;
      await this.$emit("createGroup", {
        global,
        createInputValue,
        type
      });
      this.createInputValue = "";
      this.showCreateInput = false;
    },
    async saveCategory(category, group, method = "put") {
      const headers = getTokenHeader();
      try {
        const res = await axios[method](
          `${env.poi_api_client_url}category/${
            method === "put" ? category._id : ""
          }`,
          { ...category, categoryGroup: group._id },
          { headers }
        );
        if (res.status === 200 || res.status === 201) {
          /**
           * If it is an update or only title is
           * filled for create, we are done here
           */
          if (
            method === "put" ||
            (method === "post" &&
              !category.pictureUrl &&
              !category.mappingField &&
              !category.shortTitle)
          ) {
            this.$emit("success", "Erfolgreich gespeichert!");
            this.editedCategory = null;
            this.showCategoryInput = false;

            await this.$store.dispatch("getCategoryGroupsForType", {
              categoryGroup: this.selectedType._id,
              ignorePrincipal: true
            });
          } else
          /**
           * Otherwise, we need to update the created category,
           * so the data is not lost. Probably we need to change
           * the microservice, to accept more params, then only
           * title on create.
           */
            await this.saveCategory({ ...category, _id: res.data._id }, group);
        }
      } catch (ex) {
        this.$emit("error", ex);
      }
    },
    async deleteGroup(group) {
      try {
        const confirmRes = await this.$confirm(
          `Wollen Sie die Gruppe wirklich löschen?`,
          confirmWarningConfig
        );
        if (confirmRes) {
          const headers = getTokenHeader();
          const res = await axios.delete(
            `${env.poi_api_client_url}categoryGroup/${group._id}`,
            { headers }
          );
          if (res.status === 200) {
            await this.$store.dispatch("getCategoryGroupsForType", {
              categoryGroup: this.selectedType._id,
              ignorePrincipal: true
            });

            this.$emit("success", "Erfolgreich gelöscht!");
            this.snackbarColor = "#00636C";
            this.snackbar = true;
          } else
            this.$emit(
              "error",
              `Deletion failed with status: ${res.status}, reason: (${res.statusText})`
            );
        }
      } catch (ex) {
        this.$emit("error", ex);
      }
    },
    async deleteCategory(categoryId) {
      if (categoryId) {
        try {
          const confirmRes = await this.$confirm(
            `Wollen Sie dieses Kategorie wirklich löschen?`,
            confirmWarningConfig
          );
          if (confirmRes) {
            const headers = getTokenHeader();
            const res = await axios.delete(
              `${env.poi_api_client_url}category/${categoryId}`,
              { headers }
            );
            if (res.status === 200) {
              // No need to wait for this dispatch here
              // noinspection ES6MissingAwait
              await this.$store.dispatch("getCategoryGroupsForType", {
                categoryGroup: this.selectedType._id,
                ignorePrincipal: true
              });
              this.$emit("success", "Kategorie wurde erfolgreich gelöscht");
            }
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
  },
  computed: {
    availableCategoryGroups() {
      return this.getCategoryGroups();
    },
    cSelectedCategoryGroups: {
      get() {
        if (this.selectedCategoryGroups.length) {
          return this.selectedCategoryGroups.map(scg => scg._id);
        } else return [];
      },
      set(newVal) {
        this.$emit("changedSelectedCategoryGroups", newVal);
      }
    },
    categories() {
      return flatten(
        this.categoryGroups.map(categoryGroup => categoryGroup.categories)
      );
    },
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    }
  }
};
